export default __webpack_public_path__ + "static/media/close-black.073f06a8.svg";